import { sortBy } from 'lodash';
import { OTHER_PRODUCT_ID } from '../../../constants';
import genericProducts, {
  genericProductsLookup,
} from '@shared/generic-products';
import { ProductSources } from '../../../models/product.model';
import { CeramicsProducts } from '../ceramics/ceramics.model';
import { EnergyProductId, energyProducts } from '../energy/energy.model';
import { gypsumProductMap } from '../gypsum/gypsum.model';
import { HeaterProducts } from '../heating/heating.model';
import { InsulationProducts } from '../insulation/insulation.model';
import { MetalProducts } from '../metal/metal.model';
import { reusedContentProductId } from '../reused-content-property.model';
import { woodProductMap } from '../wood/wood.model';
import { WindowsDoorsProducts } from '../windows-doors/windows-doors.model';
import { ConcreteProducts } from '../concrete/concrete.model';
import { IElementPropertyOption } from '@shared/models/element-property.model';

const categoryProductIds = [
  ...Object.values(gypsumProductMap),
  ...Object.values(woodProductMap),
  ...Object.values(ConcreteProducts),
  ...Object.values(CeramicsProducts),
  ...Object.values(WindowsDoorsProducts),
  ...Object.values(MetalProducts),
  ...Object.values(InsulationProducts),
  ...Object.values(EnergyProductId), // Had to use this directly due to circular imports
  ...Object.values(HeaterProducts),
  ...energyProducts.map(({ id }) => id),
];

// find generic products that are not in other categories or climate improved
const filteredGenericProducts = genericProducts.filter(
  ({ source, id, name }) => {
    const nameWithNoSpacesOrSpecialChars = name
      .replace(/\s+/g, '')
      .replace(/[^\w\s]/gi, '');

    const isGeneric =
      source === ProductSources.Boverket || source === ProductSources.Co2DataFi;

    return (
      isGeneric &&
      id !== reusedContentProductId &&
      !categoryProductIds.includes(id) &&
      !nameWithNoSpacesOrSpecialChars.includes('climateimproved')
    );
  },
);

const sorted = sortBy(filteredGenericProducts, 'name');

export const otherNodonProduct = genericProductsLookup[OTHER_PRODUCT_ID];

export const otherProducts = otherNodonProduct
  ? [otherNodonProduct, ...sorted]
  : sorted;

export const otherProductOptions: IElementPropertyOption[] = otherProducts.map(
  ({ name, id }) => ({
    label: name,
    value: id,
  }),
);
